/**
 * Nombre de archivo a mostrar a partir de su URL o clave. El API entrega las URLs de archivo
 * firmadas (`?X-Amz-…`): se descarta la consulta y el fragmento, y se decodifica `%XX`.
 */
export function fileNameFromUrl(url: string): string {
  const path = url.split(/[?#]/)[0] ?? '';
  const last = path.split('/').pop() ?? '';
  try {
    return decodeURIComponent(last);
  } catch {
    return last;
  }
}
